import React from 'react';
/**
 * Centered product H1 at the top of the Gen2 E-Chest Gear page.
 */
export function Title() {
  return <div className="text-center mb-12" data-id="element-399">
      <h1 className="text-3xl md:text-4xl font-bold text-red-600" data-id="element-400">
        Gen2 E-Chest Gear Adult Size
      </h1>
    </div>;
}